import classNames from 'classnames';

import MMID from '~components/MMID/MMID';
import tail from '~images/branding/tail-primary-dark.png';
import EhLogoSolid from '~images/logos/eh-logo-solid.inline.svg';

import * as styles from './MinimalFooter.module.css';

type SimpleChildElementModel = {
    type: string | { name: string };
    props: {
        children: string | Array<string | SimpleChildElementModel>;
        className: string;
        id: string;
    };
};

type Props = {
    backgroundsurface?: SupportedBackgroundColor;
    textcolor?: SupportedTextColor;
    footerbackgroundsurface?: SupportedBackgroundColor;
    showmmid?: boolean;
    showcopyright?: boolean;
    showtopgraphic?: boolean;
    showlogo?: boolean;
};

const MinimalFooter = ({
    backgroundsurface = 'bg-surface-50',
    textcolor = 'text-gray-light',
    footerbackgroundsurface = 'bg-surface-primary-darker',
    showmmid,
    showtopgraphic = true,
    showcopyright = true,
    showlogo = true,
    children = null,
}: React.PropsWithChildren<Props>) => {
    const parsedChildren = (children as Array<SimpleChildElementModel>).map((childNode) => {
        if (typeof childNode.props?.children === 'string') {
            // string nodes
            return {
                ...childNode,
                props: {
                    children: childNode.props.children,
                    className: 'text-12 leading-16 mb-4',
                    id: childNode.props.id,
                },
            } as JSX.Element;
        }

        // object nodes
        if (typeof childNode.props?.children === 'object') {
            return {
                ...childNode,
                props: {
                    children: childNode.props.children,
                    className: 'text-12 leading-16 mb-4',
                    id: childNode.props.id,
                },
            } as JSX.Element;
        }

        return childNode as JSX.Element;
    });

    return (
        <section className="w-full minimal-footer-container">
            <div
                className={classNames(
                    'flex h-min justify-start w-full mb-0 -ml-[1px]',
                    backgroundsurface
                )}
            >
                {showtopgraphic && <img src={tail} alt="" height="128" width="144" />}
            </div>
            <div className={classNames(footerbackgroundsurface)}>
                <div className="max-w-screen-xl mx-auto px-4 py-12 md:px-6 md:py-14 lg:py-20">
                    {showlogo && (
                        <div className={classNames(textcolor, 'mb-12')}>
                            <EhLogoSolid />
                        </div>
                    )}

                    {children && (
                        <div className={classNames(textcolor, styles.minimalFooter)}>
                            {parsedChildren}
                        </div>
                    )}

                    {showmmid && (
                        <MMID className={classNames(textcolor, 'text-12 leading-16 mt-4')} />
                    )}
                </div>
            </div>
            {showcopyright && (
                <div className={classNames('w-full', 'bg-surface-primary')}>
                    <div
                        className={classNames(
                            'max-w-screen-xl mx-auto px-6 py-11 flex justify-center items-center text-center font-poppins text-14 lg:text-18 leading-20 lg:leading-28',
                            'text-white'
                        )}
                    >
                        <span>© 2024 eHealthInsurance Services, Inc. All rights reserved.</span>
                    </div>
                </div>
            )}
        </section>
    );
};

export default MinimalFooter;
